import { createSlice, current } from "@reduxjs/toolkit";
import { ACTION_FILTERS } from "../../Actions/actions";
import { dashboardFilters } from "../../../src/components/Filters/Filters.constants";

export interface filterType {
  clientDashboardFilters: any;
  data: any;
  transfereeFilters: any;
}

const initialFilter = {
  divisionId: null,
  startDate: null,
  endDate: null,
};

const initialFilterAuth = {
  divisionId: null,
  startAuthDate: 0,
  endAuthDate: 0,
};

export const initialState: filterType = {
  clientDashboardFilters: {
    [dashboardFilters.TOTAL_YTD_SPEND]: initialFilter,
    [dashboardFilters.TOTAL_YTD_AUTHORISATIONS]: initialFilterAuth,
    [dashboardFilters.TOTAL_YTD_ACTIVE_FILES]: initialFilter,
    [dashboardFilters.UPCOMING_VIAS_EXPIRY]: { days: 90 },
    [dashboardFilters.assignmentExpirationCount]: { days: 90 },
    [dashboardFilters.AUTHORISATIONS_BY_POLICY]: initialFilterAuth,
    [dashboardFilters.SPENDS_BY_POLICY]: initialFilter,
    [dashboardFilters.EXCEPTIONS_BY_POLICY]: initialFilter,
    [dashboardFilters.assignmentExpiration]: {
      ...initialFilter,
      limit: 10,
      page: 1,
      assignmentType: [
        { name: "Long Term Assignment", checked: false, id: "LTA" },
        { name: "Short Term Assignment", checked: false, id: "STA" },
        { name: "Rotational Assignment", checked: false, id: "RA" },
      ],
    },
    [dashboardFilters.MAPS_DATA]: {
      map_data_filter: "OverAll",
      domestic: "false",
      // startDate: `${new Date().getFullYear()}-01-01`,
      // endDate: new Date().toISOString().split("T")[0]
    },
    [dashboardFilters.DIVISION]: { divisionId: null },
    [dashboardFilters.SERVICE_BY_POLICY]: { divisionId: null },
  },
  transfereeFilters: {
    page: 1,
    limit: 10,
    showFilters: false,
    filters: {
      country: undefined,
      state: undefined,
      policyId: undefined,
      query: undefined,
      status: undefined,
      notification: undefined,
    },
  },
  data: {},
};

const Filters = createSlice({
  name: ACTION_FILTERS,
  initialState,
  reducers: {
    updateData: (state, action) => {
      state.clientDashboardFilters = {
        ...state.clientDashboardFilters,
        [action.payload.type]: action.payload,
      };
    },
    resetData: (state, action) => {
      state.clientDashboardFilters = {
        ...state.clientDashboardFilters,
        [action.payload.type]:
          initialState.clientDashboardFilters[action.payload.type],
      };
    },
    updateTransfereeFilters: (state, action) => {
      state.transfereeFilters = action.payload;
    },
    resetClientDashboardFilters: (state) => {
      state.clientDashboardFilters = initialState.clientDashboardFilters;
    },
  },
  extraReducers: function (builder): void {},
});

export const {
  updateData,
  resetData,
  updateTransfereeFilters,
  resetClientDashboardFilters,
} = Filters.actions;

export default Filters.reducer;
